import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./CourseInformation.css";
import { BsMenuUp } from "react-icons/bs";
import { AiOutlineComment } from "react-icons/ai";
import ImageNotFound from "../../Assets/images/ImageNotFound.jpg";
import CourseSeason from "../CourseSeason/CourseSeason";
import CourseRulesComponent from "../CourseRulesComponent/CourseRulesComponent";
import CourseFeaturesBox from "../CourseFeaturesBox/CourseFeaturesBox";
import CourseLableBox from "../CourseLableBox/CourseLableBox";
import { Link } from "react-router-dom";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import UserComment from "../UserComment/UserComment";

export default function CourseInformation({ courseData }) {
    const [showDeskBox, setShowDescBox] = useState("moredetails");
    const [courseSeasonData, setCourseSeasonData] = useState([]);

    useEffect(() => {
        if (courseData.title != null) {
            axiosConfig
                .get("api/Courses/" + courseData.id + "/syllabus")
                .then((res) => {
                    setCourseSeasonData(res.data);
                });
        }
    }, [courseData.title]);

    return (
        <div className="course-information">
            <div className="course-information-navbar">
                <Container>
                    <div className="course-information-navbar-btns">
                        <button
                            className={
                                showDeskBox === "courseinformation"
                                    ? "active"
                                    : ""
                            }
                            onClick={() => setShowDescBox("courseinformation")}
                        >
                            <BsMenuUp />
                            اطلاعات دوره
                        </button>
                        <button
                            className={
                                showDeskBox === "coursecomment" ? "active" : ""
                            }
                            onClick={() => setShowDescBox("coursecomment")}
                        >
                            <AiOutlineComment />
                            دیدگاه دانشجو ها
                        </button>
                    </div>
                </Container>
            </div>
            <Container>
                <Row>
                    <Col lg={8}>
                        <div className="course-information-right">
                            <div className="course-information-desc">
                                {showDeskBox === "courseinformation" ? (
                                    <div
                                        className="desk-box"
                                        dangerouslySetInnerHTML={{
                                            __html: courseData.description,
                                        }}
                                    ></div>
                                ) : showDeskBox === "moredetails" ? (
                                    <div
                                        className="desk-box"
                                        dangerouslySetInnerHTML={{
                                            __html: courseData.description,
                                        }}
                                    ></div>
                                ) : showDeskBox === "coursesupport" ? (
                                    <div className="desk-box">
                                        شرایط پشتیبانی دوره ها
                                    </div>
                                ) : showDeskBox === "coursecomment" ? (
                                    <div className="desk-box">
                                        <UserComment itemId={courseData.id} />
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            {courseSeasonData.map((season, index) => (
                                <CourseSeason isBuyer={courseData.isUserPurchased} season={season} key={index} />
                            ))}
                            <div className="course-information-teacher">
                                <Row className="course-information-teacher-row">
                                    <Col md={12} lg={6}>
                                        <div className="course-information-teacher-right">
                                            <h1>این مدرس حرفه ای است</h1>
                                            <Link to="/aboutus">
                                                <button>
                                                    درباره مدرس بیشتر بدانید
                                                </button>
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col md={12} lg={6}>
                                        <div className="course-information-teacher-left">
                                            <div className="course-information-teacher-image">
                                                {courseData.registererUser
                                                    ?.profileImage != null ? (
                                                    <img
                                                        src={
                                                            axiosConfig.defaults
                                                                .baseURL +
                                                            "Images/UserImage/" +
                                                            courseData.registererId +
                                                            "/" +
                                                            courseData
                                                                .registererUser
                                                                .profileImage
                                                        }
                                                        alt={`تصویر ${courseData.instructorName} مدرس دوره`}
                                                    />
                                                ) : (
                                                    <img
                                                        src={ImageNotFound}
                                                        alt={`تصویر ${courseData.instructorName} مدرس دوره`}
                                                    />
                                                )}
                                            </div>
                                            <div className="course-information-teacher-name">
                                                <h3>
                                                    {courseData.instructorName}
                                                </h3>
                                                <span>مدرس</span>
                                            </div>

                                            <p className="course-information-teacher-about">
                                                {courseData.registererUser?.bio}
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className="course-information-left">
                            <CourseRulesComponent courseData={courseData} />
                            <CourseFeaturesBox courseData={courseData} />
                            <CourseLableBox courseData={courseData} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

